import { render } from "./scarp-element.vue?vue&type=template&id=a54e120e&ts=true"
import script from "./scarp-element.vue?vue&type=script&lang=ts"
export * from "./scarp-element.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__